export default "__VITE_ASSET__6052dc41__"